import React from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import ProfileImage from "../../../../src/images/SettingPageImages/profileImage.avif";
import HospitalInfo from "../../../../src/images/SettingPageImages/hospitalInformation.jpg";
import AccountLogo from "../../../../src/images/SettingPageImages/AccountLogo.jpg";
import SecurityImage from "../../../../src/images/SettingPageImages/securityImage.avif";
import ReportImage from "../../../../src/images/SettingPageImages/reportImage.avif";
import styles from "./Profile.module.scss";
const Settings = () => {
  const navigate = useNavigate();
  const data = [
    { name: "Clinic Profile", url: "/profile-setting", img: ProfileImage },
    {
      name: "Hospital Information",
      url: "/hospital-information",
      img: HospitalInfo,
    },
    { name: "Account Information", url: "/account-info", img: AccountLogo },
    { name: "Custom Reports", url: "/pdf", img: ReportImage },
    { name: "Security Settings", url: "/security-info", img: SecurityImage },
  ];
  const handleCardClick = (url) => {
    navigate(url);
  };
  return (
    <>
      <Row className={styles["setting-row"]}>
        {data &&
          data.map((item) => (
            <Col md={4} className={styles["setting-col"]}>
              <Card
                onClick={() => handleCardClick(item.url)}
                className={styles["setting-card"]}
              >
                <Card.Body className={styles["setting-card-body"]}>
                  <div className={styles["setting-card-div"]}>
                    <img src={item.img} alt={item.name}/>
                    <div>
                      <h4>{item.name}</h4>
                      <Card.Text>Some quick example text to build on</Card.Text>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default Settings;
